
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiObjectJetsam as ObiObjectJetsamElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-object-jetsam.js';
 
 
 

 
 export const ObiObjectJetsam = createComponent({
   react: React,
   tagName: 'obi-object-jetsam',
   elementClass: ObiObjectJetsamElement,
   events: {
     
   }
  });
 
 